import * as actionTypes from "./actionTypes"

export const dataLoad = (data) => ({
  type: actionTypes.DATA_LOAD,
  data,
})
